/**
 * File video-block.js
 *
 * Specific show/hide logic tied to a video-block.twig module
 *
 * @dependecies javascript
 * @version 1.1.1
 * @package coa
 *
 */

document.addEventListener("DOMContentLoaded", function(){
  const videoBlocks = document.getElementsByClassName('video-module');

  if (videoBlocks) {
    for (let video of videoBlocks) {
      if (video.getElementsByClassName('play-btn')[0]) {
        video.getElementsByClassName('play-btn')[0].addEventListener('click',(element)=>videoBlockButtonPlay(element.target));
      }
    }
  }

  /**
   *
   * @param element
   */
  function videoBlockButtonPlay(element) {
    const overviewDiv = element.closest('.overview-image');
    overviewDiv.classList.add('noDisplay');

    if (overviewDiv.parentNode.querySelectorAll('.embed-video')) {
      const videoDiv = overviewDiv.parentNode.querySelectorAll('.embed-video')[0];

      if (videoDiv.classList.contains('noDisplay')) {
        videoDiv.classList.remove('noDisplay');
      }

      if (videoDiv.getAttribute('data-video-type') === 'youtube') {
        createVideo(videoDiv.getElementsByClassName('player')[0], videoDiv.getAttribute('data-video-id'),(videoDiv.getAttribute('data-autoplay')?'true':'false'));
      } else { //vimeo
        if (videoDiv.getAttribute('data-autoplay') === '1') {
          videoDiv.getElementsByClassName('video-embed')[0].src += '&autoplay=1&muted=0'
        }
      }
    }
  }

  /**
   * Build YT videos using YT API
   *  Create a temporary iframe to store the YT API into.
   *  We do this because we are unable to fire new YT
   *  API calls once onYouTubeIframeAPIReady() is loaded
   *  on the page. By generating new iframe on each click
   *  event we can dynamically create the YT video without
   *  forcing user to load all on page load.
   *
   * @param playerElement
   * @param videoID
   * @param autoplay - defaults to false
   */
  function createVideo(playerElement, videoID, autoplay=false) {
    const tempIframe = document.createElement('iframe');
    const youtubeScriptId = 'youtube-api';

    tempIframe.setAttribute('id',videoID);
    document.body.appendChild(tempIframe);

    const tempIframeDOM = parent.document.getElementById(videoID);
    const script = tempIframeDOM.contentWindow.document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://www.youtube.com/iframe_api";
    script.id = youtubeScriptId;
    tempIframeDOM.contentWindow.document.body.appendChild(script);

    tempIframeDOM.contentWindow.onYouTubeIframeAPIReady = function() {
      return new tempIframeDOM.contentWindow.YT.Player(playerElement, {
        videoId: videoID,
        playerVars: {
          autoplay: autoplay,
          modestbranding: 1,
          rel: 0
        }
      });
    }
  }
});